import { formatCash } from "./operatorConsoleHelpers";

/** Must match betMateBackEnd REFERRAL_UNLOCK_SCORE. */
export const REFERRAL_UNLOCK_SCORE = 100;
export const FIRST_DEPOSIT_REWARD_CASH = 2000;
export const FIRST_DEPOSIT_UNLOCK_SCORE = 100;

export const REFERRAL_UNLOCK_RULE_SHORT = `${REFERRAL_UNLOCK_SCORE} all-time score + at least one bet`;

export const FIRST_DEPOSIT_RULE_SHORT = `Claim after ${FIRST_DEPOSIT_UNLOCK_SCORE} all-time score`;

export const REFERRAL_STATUS_LABELS = {
  pending: "Pending",
  rewarded: "Claimed",
  cancelled: "Cancelled",
};

export const formatReferralStatus = (status) =>
  REFERRAL_STATUS_LABELS[status] || status || "Unknown";

export const formatReferralCash = (amount) => `${formatCash(amount)} CASH`;

export const buildReferralSignupLink = (inviteCode, origin = "") => {
  const code = String(inviteCode || "").trim();
  if (!code) return "";
  const base = origin || (typeof window !== "undefined" ? window.location.origin : "");
  if (!base) return "";
  return `${base}/app/signup?ref=${encodeURIComponent(code)}`;
};

export const formatReferralJoinedShort = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

/** Label + display string for the referral list date column. */
export const getReferralRowDate = (item) => {
  if (!item) return null;

  const isRewarded = item.status === "rewarded";
  const raw = isRewarded && item.rewardedAt ? item.rewardedAt : item.createdAt;
  if (!raw) return null;

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;

  const text = date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return {
    label: isRewarded && item.rewardedAt ? "Claimed" : "Joined",
    text,
  };
};
